var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5833 20.5833H5.41667V8.66665H20.5833M17.3333 1.08331V3.24998H8.66667V1.08331H6.5V3.24998H5.41667C4.21417 3.24998 3.25 4.21415 3.25 5.41665V20.5833C3.25 21.1579 3.47827 21.709 3.8846 22.1154C4.29093 22.5217 4.84203 22.75 5.41667 22.75H20.5833C21.158 22.75 21.7091 22.5217 22.1154 22.1154C22.5217 21.709 22.75 21.1579 22.75 20.5833V5.41665C22.75 4.84201 22.5217 4.29091 22.1154 3.88458C21.7091 3.47825 21.158 3.24998 20.5833 3.24998H19.5V1.08331M18.4167 13H13V18.4166H18.4167V13Z",
    fill: "#2192FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiCalendar);
export default __webpack_public_path__ + "static/media/mdi_calendar.ccb52f9c1179e8df8e80d750dcc29c37.svg";
export { ForwardRef as ReactComponent };